// 提供给 SDK 调用，解决 iOS 下键盘弹起时页面底部被遮挡的问题
window.goToBottom = function() {
    SR.dom.$scrollWrap.scrollTop(SR.data.MAX_INTEGER);
}